import styled from 'styled-components';

const SupplierListWrapper = styled.div`
padding: 20px;
background-color: ${(props) => props.theme.colors.surface};
border-radius: 12px;
box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
margin-top: ${(props) => props.theme.spacing(4)};
`;

const SummaryTitle = styled.h3`
  font-size: 20px;
  color: ${(props) => props.theme.colors.primaryText};
  margin-bottom: ${(props) => props.theme.spacing(3)};
`;

const SupplierItem = styled.div`
  display: flex;
  flex-direction: column; /* Stack items vertically */
  padding: 10px 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.inputGray};
  margin-bottom: ${(props) => props.theme.spacing(2)};

  .header {
    display: flex;
    justify-content: space-between; /* Add space between supplier name and distance */
    width: 100%; /* Ensure the header takes full width */
    align-items: center;
  }

  .supplier-name {
    font-size: 18px;
    font-weight: bold;
  }

  .distance {
    font-size: 16px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.primaryText};
  }

  .categories-list {
    margin-top: ${(props) => props.theme.spacing(1)};
    font-size: 14px;
    color: ${(props) => props.theme.colors.textSecondary};
  }
`;
// Assuming you pass `suppliers` as a prop to this component
 const SupplierListComponent  = ({ suppliers, title, icon }) => {
    return (
      <SupplierListWrapper>
        <SummaryTitle>{icon} {title}</SummaryTitle>
        {suppliers && suppliers.length > 0 ? (
          suppliers.map((supplier) => (
            <SupplierItem key={supplier.id}>
                <div className="header">
                    <span className="supplier-name">{supplier.name}</span>
                    <span className="distance">{supplier.distance} miles</span>
                </div>
                <div className="categories-list">
                    {supplier.categories && supplier.categories.length > 0 ? (
                        supplier.categories.map((category, index) => (
                        <span key={index}>{category.name}{index < supplier.categories.length - 1 ? ', ' : ''}</span>
                        ))
                    ) : (
                        <span>No categories available</span>
                    )}
                    </div>

            </SupplierItem>
          ))
        ) : (
          <div>No suppliers found within the specified radius.</div>
        )}
      </SupplierListWrapper>
    );
  };

  export default SupplierListComponent;